<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Foreword_1#u4NcWGMn2DjyhFrVkAkK2r3">Foreword by Burl Barer</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Foreword_2#u9qK3lmXteXcFnJei6iagg2">Foreword by Branka DiGangi</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Intro#uEngWZqjKcxgUdMjV5wG839">Introduction by Paul “Punch” Stanimirovic</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_01#u3277MqvNLqez4pOITy5ET8">Chapter One - Mr. Stan</a>
</div>
<div class="sgc-toc-level-1">
<a href="#/Text/Chap_02#ulU2zhe4CFlABad36TE6JY7">Chapter Two - Branka</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_03#uWCuL3zTz3xMcxALAJo2M72" title="Link target outside of Sample">Chapter Three - The Protection Scam</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_04#uNMe8V9i9vrHoC55leGAIVC" title="Link target outside of Sample">Chapter Four - Vizcaya</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_05#u7caOLJSxAcHtFIpRGaz7O8" title="Link target outside of Sample">Chapter Five - Birth of a Bandit</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_06#uxpvOFCXpXypkADTSnuIQD2" title="Link target outside of Sample">Chapter Six - The Home Invasion</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_07#ur3f8sSUhmlSdtFfcSdzIs8" title="Link target outside of Sample">Chapter Seven - Joan Crawford</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_08#uOceJNTWgifnPgUGqzUZFsB" title="Link target outside of Sample">Chapter Eight - Alek “The Moth”</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_09#uIHi27wCxLU4O8GTQLaNfe4" title="Link target outside of Sample">Chapter Nine - Bosko</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_10#uh4AYA8QQ7br77CNbhuH8GE" title="Link target outside of Sample">Chapter Ten - Swiss Education</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_11#uNO8SooDkQ9OPSlPOMs89z3" title="Link target outside of Sample">Chapter Eleven - The Gotti Heist</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_12#ufCBKkTCLcLlrKKMlMSoW2E" title="Link target outside of Sample">Chapter Twelve - The Big Deal</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_13#uRX7H6yHJIHrWbkAeCsruu8" title="Link target outside of Sample">Chapter Thirteen - Custom Built Son</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_14#ugPsAi7ADnLQnqVgTJHuRJC" title="Link target outside of Sample">Chapter Fourteen - Back to the Diamond District</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_15#ujrvYtiAWvDSI44icLbzVP8" title="Link target outside of Sample">Chapter Fifteen - Paul’s First Heist</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_16#uis2tTWNEzYnjK4vOfzmMzC" title="Link target outside of Sample">Chapter Sixteen - Mr. Stan and Son</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_17#uT5IUvdVqRXYHdz5DAoeCCF" title="Link target outside of Sample">Chapter Seventeen - Running from New Jersey</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_18#uk57Vu7uvLsGd5iLXKmlAt2" title="Link target outside of Sample">Chapter Eighteen - Becoming Punch</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1"><span href="#/Text/Pictures" title="Link target outside of Sample">Pictures</span><br/></div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_19#uhThkkXylOv6ZoovxdJU5tA" title="Link target outside of Sample">Chapter Nineteen - Tension in the Family</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_20#uDBPlVSheLxlrWTjzFSpJp9" title="Link target outside of Sample">Chapter Twenty - Off the Rails</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_21#uYJiUlN6wqbO65D565vbwFH" title="Link target outside of Sample">Chapter Twenty-One - The Warning</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_22#uhhTMppbCbxgDeHyvVSMGs7" title="Link target outside of Sample">Chapter Twenty-Two - Something Spectacular</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_23#uNUOyhAS6ohKcLJdrWsLb7F" title="Link target outside of Sample">Chapter Twenty-Three - Carlos and Alarms</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_24#uHgdGalcWtoxVPe5oJf5sX2" title="Link target outside of Sample">Chapter Twenty-Four - Operation El Dorado</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_25#ubliGYCSNCA5WnN9iJi2YPF" title="Link target outside of Sample">Chapter Twenty-Five - Meet Mr. Lacka</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_26#uTZCHLmVirYGookfNC65n34" title="Link target outside of Sample">Chapter Twenty-Six - The Mega Heists</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_27#uO6HaJTOpF8ZhLR2XKeRtW5" title="Link target outside of Sample">Chapter Twenty-Seven - The Serbian Mafia</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_28#uYuBXXemaxt3wVopcJKC33E" title="Link target outside of Sample">Chapter Twenty-Eight - New York Nightlife</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_29#ugTgcWjx7IaHeVsoqV9kFL5" title="Link target outside of Sample">Chapter Twenty-Nine - The Regency Hotel Heist</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_30#uhULQFm3zms5ayzb4pJWok6" title="Link target outside of Sample">Chapter Thirty - 1992</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_31#uWKa4ovSqveSqssZunpbkaD" title="Link target outside of Sample">Chapter Thirty-One - The Winds of Change</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_32#ujelWbgrlGgpVGeKCYiajX9" title="Link target outside of Sample">Chapter Thirty-Two - The “head out the window” arrest</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_33#u2BTcoWWEqnlMEXBLE7HURB" title="Link target outside of Sample">Chapter Thirty-Three - The Professor</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_34#u9PV969rdVnsAO6iKKTRw89" title="Link target outside of Sample">Chapter Thirty-Four - Nightmare in a Bathtub</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_35#uIvUvmUNA3wiuxbfcEZeHc8" title="Link target outside of Sample">Chapter Thirty-Five - Prison</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_36#uiznotE7hG4T8ZxzHYGIQwG" title="Link target outside of Sample">Chapter Thirty-Six - The Incarceration Process</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Chap_37#uI9SFrfhBOg5nBf3AoY9mIH" title="Link target outside of Sample">Chapter Thirty-Seven - Everything is Altered</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?66dd5e7c